export default function useDairamon() {
    return useNuxtApp().$dairamon
}
